import { Link } from "react-router";

import type { SportsTeamRef } from "@/types/sports-refs";

/** A match-style team copy as a link to the team show page, with its crest when it has one. */
export function TeamLink({ team }: { team?: SportsTeamRef | null }) {
  const label = team?.name ?? team?.shortName ?? team?.id;
  if (!label) return <span className="text-muted-foreground">—</span>;
  const crest = team?.media?.photos?.[0]?.url;
  const content = (
    <span className="inline-flex items-center gap-2">
      {crest && (
        <img
          src={crest}
          alt=""
          width={20}
          height={20}
          className="size-5 shrink-0 object-contain"
        />
      )}
      {label}
    </span>
  );
  return team?.id ? (
    <Link to={`/teams/show/${team.id}`} className="hover:underline">
      {content}
    </Link>
  ) : (
    content
  );
}
